import React, { useEffect, useState } from 'react';
import Post from '../../Post';
import Spacing from '../../Spacing';
import { getDentalServices } from '../../../service/api';
import dayjs from 'dayjs';
import { previewAssetUrl } from '../../../helpers';

const TYPE_LABELS = {
  orthodontics: 'Chỉnh nha',
  implant: 'Cấy ghép Implant',
  cosmetic_dentistry: 'Răng sứ thẩm mỹ',
  general_dentistry: 'Nha khoa tổng quát',
};

export default function ServiceSectionList({ type }) {
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const limit = 9;

  const fetchData = async (pageNum = 1) => {
    try {
      const res = await getDentalServices({
        filter: { type: type.toUpperCase(), show: true },
        page: pageNum,
        limit,
        sort: { position: 1 },
      });
      setData(res?.data);
    } catch (err) {
      setData({ docs: [], totalPages: 1, page: 1 });
    }
  };

  useEffect(() => {
    setPage(1);
    fetchData(1);
  }, [type]);

  useEffect(() => {
    fetchData(page);
  }, [page]);

  return (
    <div className='container'>
      <div className='row cs_row_gap_50'>
        {data?.docs.map((item, index) => {
          const postProps = {
            title: item.title,
            thumbUrl: previewAssetUrl(item.assetId),
            date: dayjs(item.createdAt).format('DD/MM/YYYY'),
            href: `/services/${type}/${item._id || item.id}`,
            socialShare: true,
            description: item.description,
          };
          return (
            <div className='col-xl-4 col-md-6' key={index}>
              <Post {...postProps} />
            </div>
          );
        })}
      </div>
      {data?.docs?.length === 0 && (
        <div className='text-center cs_fs_18'>Chưa có bài viết nào</div>
      )}
      {data?.docs?.length > 0 && (
      <>
      <Spacing md='110' lg='70' />
      <ul className='cs_pagination_box'>
        <li>
          <button
            className='cs_pagination_arrow cs_center'
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            <img src='/images/icons/left_arrow_blue.svg' alt='Icon' />
          </button>
        </li>
        {Array.from({ length: data?.totalPages || 1 }, (_, i) => i + 1).map(
          (p) => (
            <li key={p}>
              <button
                className={`cs_pagination_item cs_center${
                  page === p ? ' active' : ''
                }`}
                onClick={() => setPage(p)}
              >
                {p}
              </button>
            </li>
          )
        )}
        <li>
          <button
            className='cs_pagination_arrow cs_center'
            disabled={page === (data?.totalPages || 1)}
            onClick={() => setPage(page + 1)}
          >
            <img src='/images/icons/right_arrow_blue.svg' alt='Icon' />
          </button>
        </li>
      </ul>
      </>
      )}
    </div>
  );
}

export { TYPE_LABELS };
